import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import PlotWrapper from '../../common/PlotWrapper';
import Table from './Table';
import SimpleList from './SimpleList';
import PaginationBar from '../../common/PaginationBar';
import useStyles from './styles';


const perPage = 5;

const PaginationContainer = ({ data }) => {
  const isMobile = useMediaQuery('(max-width:900px)');
  const [page, setPage] = useState(1);
  const { t } = useTranslation(['translation'])
  const classes = useStyles();

  const headerNames = [
    t('ANALYTICS.CAMPAIGN_TABLE_NAME'),
    t('ANALYTICS.CAMPAIGN_TABLE_FORMAT'),
    t('ANALYTICS.CAMPAIGN_TABLE_STATE'),
    t('ANALYTICS.CAMPAIGN_TABLE_DELIVERY'),
    t('ANALYTICS.CAMPAIGN_TABLE_END_DATE'),
  ];

  const { campaigns } = data;
  // const campaigns = Array.from({ length: 53 }, (v, i) => ({
  //   id: i,
  //   active: 1,
  //   name: `test-${i}`,
  //   dateEnd: '2021-11-02',
  //   type: 'App',
  //   KPIs: 'test',
  // }))

  const pages = Math.ceil(campaigns.length / perPage);
  const paginatedData = campaigns.slice((page - 1) * perPage, page * perPage)

  return (
    <PlotWrapper
      title={t('ANALYTICS.CAMPAIGN_TITLE')}
      overriddenClasses={classes}
    >
      {isMobile
        ? <SimpleList data={paginatedData} />
        : <Table data={paginatedData} headerNames={headerNames} />
      }
      {pages > 1 && (
        <PaginationBar
          pages={pages}
          active={page}
          setPage={setPage}
        />
      )}
    </PlotWrapper>
  );
};


export default PaginationContainer;
